import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Modal, Spin, Table } from 'antd';
import moment from 'moment';
import squareCatalogApi from '../../../services/squareCatalogApi';
import squareErrorToast from '../../../components/menu/square-shared/squareErrorToast';

const parseSyncMoment = (value) =>
  moment(value.endsWith('Z') ? value : value + 'Z');

const SyncHistoryModal = ({ open, onClose }) => {
  const globalCompany = useSelector((state) => state.companyReducer.selected);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!open || !globalCompany?.id) return undefined;
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await squareCatalogApi.syncHistory(globalCompany.id);
        if (!cancelled) setRows(res.data.data || []);
      } catch (err) {
        if (!cancelled) {
          squareErrorToast(err);
          onClose();
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open, globalCompany?.id]);

  return (
    <Modal title="Sync history" open={open} onCancel={onClose} footer={null} width={640}>
      {loading ? (
        <div className="flex justify-center py-8">
          <Spin />
        </div>
      ) : rows.length === 0 ? (
        <p className="py-4 text-sm text-gray-600 dark:text-slate-300">
          No syncs yet.
        </p>
      ) : (
        <Table
          size="small"
          pagination={false}
          rowKey={(_, i) => i}
          dataSource={rows}
          columns={[
            {
              title: 'Time',
              dataIndex: 'syncat',
              render: (v) => parseSyncMoment(v).format('MMM D, HH:mm'),
            },
            {
              title: 'Trigger',
              dataIndex: 'triggertype',
              render: (v) => (v === 20 ? 'Auto' : 'Manual'),
            },
            {
              title: 'Summary',
              dataIndex: 'summary',
              render: (s) =>
                s
                  ? `${s.pricesupdated} prices, ${s.namesupdated} names, ${s.addedhidden} added hidden`
                  : '—',
            },
          ]}
        />
      )}
    </Modal>
  );
};

export default SyncHistoryModal;
